import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom'
import axios from 'axios'
import { AODetailComponent, AOResumeComponent } from './GetAO';
import moment from 'moment';
import { AOMatchedResultsComponent, ResultMatchAOComponent } from './AOMatched';

export const FeedbackComponent = () => {

    const { id } = useParams();
    const [result, setResult] = useState(undefined);
    const [nbCount, setNbCount] = useState(0);

    useEffect(() => {

        var url = "/api/feedback/result";

        if (id) {
            url += "?id=" + id;
        }

        axios.get(url).then(
            response => {
                if ( response.status === 200 && response.data) {
                    setResult(response.data)
                    setNbCount(nbCount + 1)
                }
            }
        );

    },[id]);

    if (!result) {
        return <div className="alert alert-danger">feedback non trouvé</div>
    }

    const getFeedback = () => {
        return new Promise(resolve => resolve({ status: 200, data: result.feedbacks }))
    }

    const aoParsed = { value: result.appelOffre };

    var  previousIcon = <span></span>;
    if (result.previousId) {
        previousIcon = <Link to={'/aos/feedback/' + result.previousId}><i className="pi pi-arrow-circle-left text-primary"  ></i></Link>
    }

    var nextIcon = <span></span>
    if ( result.nextId) {
        nextIcon = <Link to={'/aos/feedback/' + result.nextId}><i className="pi pi-arrow-circle-right text-primary"  ></i></Link>
    }

    var dateFeedback = <></>
    if (result.dateFeedback) {
        dateFeedback =  <span>Feedback du { moment(result.dateFeedback).format('L') }</span>
    }

    return <div>
        <div className="d-flex flex-row justify-content-between"> {previousIcon} {dateFeedback} {nextIcon}</div>
        <AOResumeComponent aoParsed={aoParsed}></AOResumeComponent>
        <AODetailComponent aoParsed={aoParsed} dontDisplayErrorAndWarning={true} ></AODetailComponent>
        <AOMatchedResultsComponent matchingResults={result.results} aoParsed={aoParsed} getFeedback={getFeedback} aoId={ nbCount } />
    </div>
}





